import React, { useEffect, useState } from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import { Button } from 'react-bootstrap';
import '../../assets/Styles/SimulationCSS/SliderSim.css';

const MTS_EmailVerification = ({ HideEmailVerificatinDialog, onStartClick, onSaveEmailDetails, slotMessage, overWritePolygone }) => {
    const [templateUserEmail, setTemplateUserEmail] = useState("info@itcurves.us");
    const [email, setEmail] = useState("");
    useEffect(() => {
        if(email == templateUserEmail){
            setIsShowOverwriteCheckbox (true);
        }
        else{
            setIsShowOverwriteCheckbox (false);
        }
    }, [email]);

    const [emailError, setEmailError] = useState('');

    const isValidEmail = (email) => {
        // Basic email regex pattern for validation
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailPattern.test(email);
    };

    const onClickCancelHideEmailVerification = () => {
        try {
            HideEmailVerificatinDialog(true);
        } catch (error) {
            console.error("Error hiding email verification dialog", error);
        }
    }

    const onClickSTartSimulation = () => {
        try {

            if (!isValidEmail(email)) {
                setEmailError("Please enter a valid email address.");
                return;
            }
            // Ensure that the email is properly passed when the Start button is clicked
            setEmailError("")
            onSaveEmailDetails(email);
            //onStartClick(true);
        } catch (error) {
            console.error("Error starting simulation", error);
        }
    }

    const [isShowOverwriteCheckbox, setIsShowOverwriteCheckbox] = useState(false);
    const [isChecked, setIsChecked] = useState(false);

    const handleCheckboxChange = (event) => {
        setIsChecked(event.target.checked);
        overWritePolygone(event.target.checked);
    };



    return (
        <div id="MTS_Trips_Information_Componenet">
            <h4>Launch Simulation</h4>
            {emailError && <div style={{ color: "red", marginBottom: "10px" }}>{emailError}</div>}
            <label>Email</label>
            <input 
                type="text" 
                value={email} 
                onChange={(e) => setEmail(e.target.value)} 
                placeholder="Enter your email address..." 
                id="card-checkbox" 
                style={{ marginBottom: "10px", height: "40px", fontSize: "larger" }} 
            />
            <br></br>
            <br></br>
            {isShowOverwriteCheckbox && ( <label>
                <input
                    type="checkbox"
                    checked={isChecked}
                    onChange={handleCheckboxChange}
                /> Overwrite Polygon
                </label>
            )}

            {/* <label >Verification Code: </label>
            <input 
                type="text" 
                id="card-checkbox" 
                style={{ marginBottom: "10px", height: "40px", fontSize: "larger" , display: None}} 
            /> */}
            <label style={{color:"beige"}} id="MTS_EmailVerification_ValidationMsg">{slotMessage}</label>
            <div id="MTS_TIC_ButonsDiv">
                <button id="MTS_TIC_BackBtn" onClick={onClickCancelHideEmailVerification}>Cancel</button>
                {/* <button id="MTS_TIC_CancelBtn">Resend</button> */}
                {/* <button id="MTS_TIC_CancelBtn">Verify</button> */}
                <button id="MTS_TIC_StartBtn" onClick={onClickSTartSimulation}>Start</button>
            </div>
        </div>
    );
};

export default MTS_EmailVerification;
